import { AuthState, initialState } from './auth.state';
import { createReducer, on } from '@ngrx/store';
import {
  loginAttempted,
  loginFailed,
  loginSuccessful,
  logoutSuccessful,
  ssoLogin,
} from './auth.actions';

export const authReducer = createReducer(
  initialState,
  on(loginAttempted, (state, { payload }) => ({
    ...state,
    busy: true,
  })),
  on(loginFailed, (state, { payload }) => ({
    ...state,
    busy: false,
  })),
  on(loginSuccessful, (state, { payload }) => ({
    ...state,
    token: payload,
    busy: false,
  })),
  on(logoutSuccessful, (state, { payload }) => ({
    ...state,
    busy: false,
  })),
  on(ssoLogin, (state, { payload }) => ({
    ...state,
    busy: true,
    ssoLink: payload,
  })),
);
